// extracted by mini-css-extract-plugin
export default {"reactMarkdown":"App_reactMarkdown__fUkjf"};